export const geocode = async (
    request: google.maps.GeocoderRequest,
): Promise<google.maps.GeocoderResult[]> => {
    const geocoder = new google.maps.Geocoder();
    const resp = await geocoder.geocode(request);
    return resp.results;
};
